
import { mapGetters } from 'vuex'
export default {
  props: {
    // items: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   },
    // },
    favoriteList: {
      type: Array,
      default: Array,
    },
    redeemed_discount: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      // Catalog
      createFavorite: {
        name: '',
      },
      isCreateFavorite: false,
      selectedFavorite: '',
      //   mergedOrders: [],
      //   selectInstallmentTooltip: '',
      // items: [],
    }
  },
  computed: {
    ...mapGetters('authen', [
      'openId',
      'isAuthenticated',
      'isGuest',
      'guestId',
    ]),
    // ...mapState('cart', ['cartId']),
    ...mapGetters('user', [
      'userProfile',
      // 'userInfo',
      'profileType',
      // 'userCostcenter',
    ]),
    isAuthen() {
      return this.isAuthenticated !== null && this.isAuthenticated !== undefined
        ? this.isAuthenticated
        : false
    },
  },
  mounted() {
    console.log('redeemed_discount', this.redeemed_discount)
  },
  methods: {
    hasItemInFavoriteList(sku_code) {
      if (this.favoriteList.length) {
        let isMatch = false
        this.favoriteList.forEach((favorite) => {
          if (favorite.items.length) {
            if (
              favorite.items.find((q) => q.sku_code === sku_code) !== undefined
            )
              isMatch = true
          }
        })
        return isMatch
      } else return false
    },
    hasItemInFavorite(favorite, sku_code) {
      if (favorite.items.length) {
        return favorite.items.find((q) => q.sku_code === sku_code) !== undefined
          ? true
          : false
      } else return false
    },
    onClickFavorite() {
      this.selectedFavorite = ''
      this.isCreateFavorite = false
      this.createFavorite.name = ''
    },
    onAddFavorite(favorite, sku_code, quantity) {
      let id = favorite.id
      // let qty = 1
      // quantity = favorite.items.some((q) => q.sku_code) ? 0 : quantity
      this.$emit('addToFavorite', { id, sku_code, quantity: 1 })
    },
    onNewFavorite() {
      this.$emit('createNewFavorite', this.createFavorite.name)
    },
    async onRemoveItem(product) {
      await this.$shoppingCartProvider
        .removePWPCart(this.openId, this.userProfile.id, product.sku_code)
        .then(
          async (result) => {
            if (result.status === 200) {
              this.$nuxt.$emit('reloadCart')
            }
          },
          (error) => {
            console.log('getPromotionProduct', error.responsed)
          }
        )
    },
    imgError($event) {
      $event.target.src =
        'https://ofm-cdn0.ofm.co.th/images/image-product-default-thumbnail.jpg'
      $event.target.srcset = this.$utils.genImgSrcSet(
        'https://ofm-cdn0.ofm.co.th/images/image-product-default-thumbnail.jpg',
        [
          { w: 115, h: 115, q: 90, ws: '115w' },
          { w: 150, h: 150, q: 90, ws: '150w' },
        ]
      )
    },
    calculatePromotionQuantityDiscount(
      originalPrice,
      discountPrice,
      campaignType,
      discountType,
      discountAmt
    ) {
      return campaignType === 'FixedPrice'
        ? `${this.$t('cart.cartItem.labelSave')} ${Math.round(
            ((originalPrice - discountPrice) / originalPrice) * 100
          )}%`
        : discountType === 'Baht'
        ? `${this.$t('cart.cartItem.lableQuantityDiscount')} ฿ ${discountAmt}`
        : `${this.$t('cart.cartItem.lableQuantityDiscount')} ${discountAmt}%`
    },
    highlightActiveTier(activeId, pro) {
      return pro.id === activeId ? true : false
    },
  },
}
